/**
 * Reading a configured { label, key, source, fallback } field from the Digital Twin's data
 * sources. Shared by the configurable header (headerConfig.js re-exports these) and the
 * Vitals ID box (vehicleIdentifier.js), so both read org meta the same way.
 *
 * sources: { batteryInfo, vehicleInfo, iotState, node, ... }; a field's source defaults to
 * "batteryInfo".
 */

/** One value from the sources, by { key, source }; null when missing or blank. */
export const valueFromSource = (sources, field) => {
    if (!field?.key) return null;
    const value = sources?.[field.source || "batteryInfo"]?.[field.key];
    if (value === undefined || value === null) return null;
    return typeof value === "string" && value.trim() === "" ? null : value;
};

/** { label, value } for a field: the field itself, else its fallback when the value is empty. */
export const resolveTitle = (primaryDetails, sources) => {
    const primary = primaryDetails || {};
    const value = valueFromSource(sources, primary);
    if (value !== null || !primary.fallback) return { label: primary.label || "", value };
    const fallback = primary.fallback;
    return { label: fallback.label ?? primary.label ?? "", value: valueFromSource(sources, fallback) };
};
